import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, Select } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const RelationshipStatus = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const isDirector = useWatch({
    control,
    name: `subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.director`
  })
  const isEmployee = useWatch({
    control,
    name: `subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.employee`
  })
  const isOfficer = useWatch({ control, name: `subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.officer` })
  const isOwner = useWatch({ control, name: `subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.owner` })
  const isStatusEnabled = isDirector || isEmployee || isOfficer || isOwner

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.relationshipsInfo.${index2 as 0}.relationshipStatus`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="25. Status of relationship"
          input={(props) => (
            <Select
              {...props}
              data={[
                { label: 'Relationship continues', value: 'Relationship continues' },
                { label: 'Terminated', value: 'Terminated' },
                { label: 'Suspended/barred', value: 'Suspended/barred' },
                { label: 'Resigned', value: 'Resigned' }
              ]}
              data-qa="84. State"
              options-data-qa="84. State option"
              disabled={!isStatusEnabled}
            />
          )}
        />
      )}
    />
  )
}
